import { render, staticRenderFns } from "./Jan15.vue?vue&type=template&id=674c510c&scoped=true&"
import script from "./Jan15.vue?vue&type=script&lang=js&"
export * from "./Jan15.vue?vue&type=script&lang=js&"
import style0 from "./Jan15.vue?vue&type=style&index=0&id=674c510c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c510c",
  null
  
)

export default component.exports